export const MSG_PLACEHOLDERS_MANDATORY_SENDER_INFO = [
  '_mandatory_sender_info_address',
  '_mandatory_sender_info_city',
  '_mandatory_sender_info_company',
  '_mandatory_sender_info_contact',
  '_mandatory_sender_info_country',
  '_mandatory_sender_info_permission_reminder',
  '_mandatory_sender_info_phone',
  '_mandatory_sender_info_postalcode',
  '_mandatory_sender_info_state',
  '_mandatory_sender_info_website'
]

export const MSG_PLACEHOLDERS_SENDING_DATE = [
  '_currentday',
  '_currentdayname',
  '_currentmonth',
  '_currentmonthname',
  '_currentyear'
]

export const MSG_PLACEHOLDERS_SUBSCRIBER_INFO = [
  '_hash',
  '_idlist',
  '_idnl',
  '_idoptin',
  '_ip_conf_sub',
  '_ip_req_sub',
  '_subemail',
  '_subsms',
  'email',
  'idu',
  'number',
  'prefix'
]

export const MSG_PLACEHOLDERS_SPECIAL_LINKS = [
  'NOTRACK_LINK',
  'PREFCENT_LINK',
  'ShareOn',
  'SUB_LINK',
  'UNS_LINK',

  'autoprofile',
  'donottrack',
  'listunsubscribe',
  'mailto_uns',
  'prefcenter',
  'staticnl',
  'subscribelink',
  'track',
  'unsubscribe'
]
